import { ComponentType, SVGProps } from 'react';

import {
  Aspira,
  AspiraNeutral,
  Capax,
  CapaxNeutral,
  CataSailing,
  CataSailingNeutral,
  CityOfSplit,
  CityOfSplitNeutral,
  CroatiaYachting,
  CroatiaYachtingNeutral,
  Des,
  DesNeutral,
  Fabrique,
  FabriqueNeutral,
  HyperlightOptics,
  HyperlightOpticsNeutral,
  Mucic,
  MucicNeutral,
  OceanSailingHouse,
  OceanSailingHouseNeutral,
  Paprac,
  PapracNeutral,
  ProDesk,
  ProDeskNeutral,
  ReflectNetwork,
  ReflectNetworkNeutral,
  Sailweek,
  SailweekNeutral,
  SeaEU,
  SeaEUNeutral,
  Serwizz,
  SerwizzNeutral,
  TehnoloskiParkSplit,
  TehnoloskiParkSplitNeutral,
  TerminalF,
  TerminalFNeutral,
  UniversityOfSplit,
  UniversityOfSplitNeutral,
  VitaBenedicta,
  VitaBenedictaNeutral,
  Zepter,
  ZepterNeutral,
  Znjan,
  ZnjanNeutral,
} from '@/components/SvgIcons/Partners';

export interface Partner {
  id: string;
  name: string;
  Colored: ComponentType<{ props?: SVGProps<SVGSVGElement>; size?: string | number }>;
  Neutral: ComponentType<{ props?: SVGProps<SVGSVGElement>; size?: string | number }>;
}

export const partners: Partner[] = [
  {
    id: 'aspira',
    name: 'Aspira',
    Colored: Aspira,
    Neutral: AspiraNeutral,
  },
  {
    id: 'capax',
    name: 'Capax',
    Colored: Capax,
    Neutral: CapaxNeutral,
  },
  {
    id: 'cata-sailing',
    name: 'Cata Sailing',
    Colored: CataSailing,
    Neutral: CataSailingNeutral,
  },
  {
    id: 'city-of-split',
    name: 'City of Split',
    Colored: CityOfSplit,
    Neutral: CityOfSplitNeutral,
  },
  {
    id: 'croatia-yachting',
    name: 'Croatia Yachting',
    Colored: CroatiaYachting,
    Neutral: CroatiaYachtingNeutral,
  },
  {
    id: 'des',
    name: 'DES',
    Colored: Des,
    Neutral: DesNeutral,
  },
  {
    id: 'fabrique',
    name: 'Fabrique',
    Colored: Fabrique,
    Neutral: FabriqueNeutral,
  },
  {
    id: 'hyperlight-optics',
    name: 'Hyperlight Optics',
    Colored: HyperlightOptics,
    Neutral: HyperlightOpticsNeutral,
  },
  {
    id: 'mucic',
    name: 'Mučić',
    Colored: Mucic,
    Neutral: MucicNeutral,
  },
  {
    id: 'ocean-sailing-house',
    name: 'Ocean Sailing House',
    Colored: OceanSailingHouse,
    Neutral: OceanSailingHouseNeutral,
  },
  {
    id: 'paprac',
    name: 'PAP/RAC',
    Colored: Paprac,
    Neutral: PapracNeutral,
  },
  {
    id: 'pro-desk',
    name: 'Pro Desk',
    Colored: ProDesk,
    Neutral: ProDeskNeutral,
  },
  {
    id: 'reflect-network',
    name: 'Reflect Network',
    Colored: ReflectNetwork,
    Neutral: ReflectNetworkNeutral,
  },
  {
    id: 'sailweek',
    name: 'Sailweek',
    Colored: Sailweek,
    Neutral: SailweekNeutral,
  },
  {
    id: 'sea-eu',
    name: 'Sea EU',
    Colored: SeaEU,
    Neutral: SeaEUNeutral,
  },
  {
    id: 'serwizz',
    name: 'Serwizz',
    Colored: Serwizz,
    Neutral: SerwizzNeutral,
  },
  {
    id: 'tehnoloski-park-split',
    name: 'Technology Park Split',
    Colored: TehnoloskiParkSplit,
    Neutral: TehnoloskiParkSplitNeutral,
  },
  {
    id: 'terminal-f',
    name: 'Terminal F',
    Colored: TerminalF,
    Neutral: TerminalFNeutral,
  },
  {
    id: 'university-of-split',
    name: 'University of Split',
    Colored: UniversityOfSplit,
    Neutral: UniversityOfSplitNeutral,
  },
  {
    id: 'vita-benedicta',
    name: 'Vita Benedicta',
    Colored: VitaBenedicta,
    Neutral: VitaBenedictaNeutral,
  },
  {
    id: 'zepter',
    name: 'Zepter',
    Colored: Zepter,
    Neutral: ZepterNeutral,
  },
  {
    id: 'znjan',
    name: 'Žnjan',
    Colored: Znjan,
    Neutral: ZnjanNeutral,
  },
];
